export const DRIVER_WORKSPACE_TYPES = {
  cityxpress: "cityxpress",
  intransit: "intransit",
  cargo: "cargo",
}

export const getDriverWorkspaceLabel = (workspaceType) => {
  switch (workspaceType) {
    case DRIVER_WORKSPACE_TYPES.intransit:
      return "InTransit"
    case DRIVER_WORKSPACE_TYPES.cargo:
      return "Cargo"
    case DRIVER_WORKSPACE_TYPES.cityxpress:
    default:
      return "CityXpress"
  }
}

export const getDriverWorkforceLabel = (workforceType, workspaceType) => {
  switch (workforceType) {
    case "intransit_worker":
      return "InTransit Worker"
    case "cargo_fleet_driver":
      return "Cargo Fleet Driver"
    case "cityxpress_driver":
      return "CityXpress Driver"
    default:
      return `${getDriverWorkspaceLabel(workspaceType)} Profile`
  }
}

export const workforceTypeToWorkspaceType = (workforceType) => {
  switch (workforceType) {
    case "cityxpress_driver":
      return DRIVER_WORKSPACE_TYPES.cityxpress
    case "intransit_worker":
      return DRIVER_WORKSPACE_TYPES.intransit
    case "cargo_fleet_driver":
      return DRIVER_WORKSPACE_TYPES.cargo
    default:
      return DRIVER_WORKSPACE_TYPES.cityxpress
  }
}

export const resolveDriverWorkspaceType = (user) => {
  return (
    user?.active_profile?.workspace_type ||
    user?.workspace_type ||
    workforceTypeToWorkspaceType(user?.active_workforce_type || user?.workforce_context?.type || user?.details?.workforce_type)
  )
}

export const normalizeDriverCapabilities = (user) => {
  const rawCapabilities = user?.capabilities || user?.service_capabilities || user?.active_profile?.capabilities || user?.details?.service_capabilities || {}
  const workspaceType = resolveDriverWorkspaceType(user)

  const cityxpressEnabled = Boolean(rawCapabilities.cityxpress_enabled ?? (workspaceType === DRIVER_WORKSPACE_TYPES.cityxpress))
  const intransitEnabled = Boolean(rawCapabilities.intransit_enabled ?? (workspaceType === DRIVER_WORKSPACE_TYPES.intransit))
  const cargoEnabled = Boolean(rawCapabilities.cargo_enabled ?? (workspaceType === DRIVER_WORKSPACE_TYPES.cargo))
  const canManageVehicle = Boolean(rawCapabilities.can_manage_vehicle ?? (workspaceType === DRIVER_WORKSPACE_TYPES.cityxpress))
  const requiresVehicle = Boolean(rawCapabilities.requires_vehicle ?? (workspaceType === DRIVER_WORKSPACE_TYPES.cityxpress || workspaceType === DRIVER_WORKSPACE_TYPES.cargo))
  const carrierManaged = Boolean(rawCapabilities.carrier_managed ?? user?.details?.carrier_id)
  const availabilityControlsEnabled = Boolean(rawCapabilities.availability_controls_enabled ?? cityxpressEnabled)

  return {
    ...rawCapabilities,
    cityxpress_enabled: cityxpressEnabled,
    intransit_enabled: intransitEnabled,
    cargo_enabled: cargoEnabled,
    can_manage_vehicle: canManageVehicle,
    requires_vehicle: requiresVehicle,
    carrier_managed: carrierManaged,
    availability_controls_enabled: availabilityControlsEnabled,
  }
}

export const canAccessDriverRoute = (user, path) => {
  const capabilities = normalizeDriverCapabilities(user)

  if (
    path === "/driver" ||
    path.startsWith("/driver/settings") ||
    path.startsWith("/driver/support") ||
    path.startsWith("/driver/payments")
  ) {
    return true
  }

  if (path.startsWith("/driver/cityxpress")) {
    return capabilities.cityxpress_enabled
  }

  if (path.startsWith("/driver/intransit")) {
    return capabilities.intransit_enabled
  }

  if (path.startsWith("/driver/shipments")) {
    return capabilities.cargo_enabled
  }

  if (path.startsWith("/driver/vehicle")) {
    return capabilities.can_manage_vehicle
  }

  return true
}

export const defaultDriverWorkspaceRoute = (user) => {
  const capabilities = normalizeDriverCapabilities(user)

  if (capabilities.cityxpress_enabled) return "/driver/cityxpress"
  if (capabilities.intransit_enabled) return "/driver/intransit"
  if (capabilities.cargo_enabled) return "/driver/shipments"

  return "/driver"
}
